import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, ChangeDetectorRef, effect, inject } from '@angular/core';
import { HardwareVariant } from '../../../models/mobilephone-variant';
import { PriceType } from '@shared/pipes/price-format.pipe';
import { IconNames } from '@shared/enums/icon-names';
import { GradingQuestion } from '../../../models/equipment-api.model';
import { select, Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ResetRedemptionDetailsAction, SetReturnDetailsAction } from '../../../states/mobilbytte/mobilbytte.actions';
import { PrivateCustomer } from '@sales/modules/details/models/private-customer.model';
import { MobilePhoneFormControls } from '../../mobilephone-search/mobilephone-details/mobilephone-details.component';
import { CustomerProductSelectors } from '@sales/states/customer-product/customer-product.selectors';
import { MobilePaymentType } from '@sales/enums/mobile-payment-type';
import { OfferingSelectors } from '@sales/states/offering/offering.selectors';
import { DealerStateSelectors } from '@core/states/dealer/dealer-state.selectors';
import { CustomerSelectors } from '@sales/modules/details/states/customer.selectors';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiGetStockAction } from '@sales/states/warehouse/warehouse.actions';
import { CustomerEquipmentUpgradeAgreement, MobileReturnMethod } from '../../../models/equipment-upgrade-agreement.model';
import { MobilBytteSelectors } from '../../../states/mobilbytte/mobilbytte.selectors';
import { OldMobilePhoneDetailsComponent } from './old-mobile-phone-details/old-mobile-phone-details.component';
import { NewMobilePhoneDetailsComponent } from './new-mobile-phone-details/new-mobile-phone-details.component';
import { MobilePhoneHeaderComponent } from './mobilephone-header/mobilephone-header.component';
import { MobilephoneInfoComponent } from '../../mobilephone-search/mobilephone-details/mobilephone-info/mobilephone-info.component';
import { OpenDialogService } from '@app/core/services/open-dialog.service';
import { CustomerServiceProductSelectors } from '@app/sales/states/customer-service-product/customer-service-product.selectors';
import { MobilBytteHelperService } from '@app/sales/services/mobilbytte-helper.service';
import { NgClass } from '@angular/common';
import { AddMobilePhoneReplacementAction } from '@app/sales/states/customer-product-mobilephone/customer-product-mobilephone.actions';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

//This component is used purely for EquipmentUpgradeUpgrade
@Component({
  selector: 'app-mobilephone-mobilbytte-bytte-details',
  templateUrl: './mobilephone-mobilbytte-bytte-details.component.html',
  styleUrls: ['./mobilephone-mobilbytte-bytte-details.component.scss'],
  imports: [
    MobilephoneInfoComponent,
    MobilePhoneHeaderComponent,
    FormsModule,
    ReactiveFormsModule,
    NewMobilePhoneDetailsComponent,
    OldMobilePhoneDetailsComponent,
    NgClass,
    IceAlertComponent,
  ],
})
export class MobilephoneMobilbytteBytteDetailsComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private formBuilder = inject(FormBuilder);
  private openDialogService = inject(OpenDialogService);
  mobilBytteHelperService = inject(MobilBytteHelperService);
  data = inject<{
    route: ActivatedRoute;
  }>(MAT_DIALOG_DATA);

  PriceType = PriceType;
  IconNames = IconNames;
  MobilePhoneFormControls = MobilePhoneFormControls;
  MobilePaymentType = MobilePaymentType;

  @Input() mobilePhoneVariant: HardwareVariant;
  @Input() mobilePhoneGroupVariants: HardwareVariant[];
  @Input() equipmentUpgradeAgreement: CustomerEquipmentUpgradeAgreement;
  @Input() equipmentUpgradeAgreementId: string;
  @Input() isManualRegistration: boolean;
  @Input() gradingQuestions: GradingQuestion[];

  @Input() isInsuranceRequired: boolean;
  @Input() customer: PrivateCustomer;
  @Output() backToSearch = new EventEmitter();
  @Output() gradingCompleted = new EventEmitter();
  @Output() oldMobileSelectionChanged = new EventEmitter();

  allVoiceOfferings = select(OfferingSelectors.getAllOfferings);
  existingVoiceProducts = select(CustomerProductSelectors.getExistingVoiceProducts);
  canSellHardwareWithLogisticsClaim = select(DealerStateSelectors.canSellHardwareWithLogistics);
  hasPerformedDetailedCreditCheck = select(CustomerSelectors.hasPerformedDetailedCreditCheck);
  isEquipmentUpgradePreCheckSuccessful = select(CustomerSelectors.isEquipmentUpgradePreCheckSuccessful);
  isEquipmentUpgradeEnabled = select(DealerStateSelectors.isEquipmentUpgradeEnabled);
  hasSubscriptionsAvailableForRedemption = select(CustomerSelectors.hasSubscriptionsAvailableForRedemption);
  existingProductsAvailableForEquipmentUpgradeUpgrade = select(
    CustomerProductSelectors.getExistingVoiceSubscriptionsAvailableForEquipmentUpgradeUpgrade
  );
  isSubscriptionLimitReached = select(CustomerProductSelectors.isSubscriptionLimitReached);
  existingEquipmentUpgradeAgreements = select(MobilBytteSelectors.existingEquipmentUpgradeAgreements);
  assignedMobileInsurances = select(CustomerServiceProductSelectors.getAssignedMobileInsurances);

  newMobilePhoneVariant: HardwareVariant;
  newMobilePhoneImei: string;
  image: string;
  isOldMobileSelected: boolean;
  selectedExistingSubscriptionId: string;
  newMobileForm: FormGroup = this.formBuilder.group({});
  isLoadingMobilePhoneOffering: boolean;

  subscriptions$: Subscription[] = [];

  constructor() {
    effect(() => {
      this.selectedExistingSubscriptionId = this.existingVoiceProducts().find(
        v => v.subscription?.msisdn === this.equipmentUpgradeAgreement.relatedMsisdn
      )?.id;
    });

    effect(() => {
      this.equipmentUpgradeAgreement = this.existingEquipmentUpgradeAgreements().find(
        a => a.agreementId === this.equipmentUpgradeAgreementId
      );
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnInit() {
    // get warehouse status for each offering id (each color and memory variation has a different offeringId)
    const offerings = [];
    this.mobilePhoneGroupVariants.map(variant => offerings.push(variant.offeringId));

    this.store.dispatch(new ApiGetStockAction(offerings));

    this.equipmentUpgradeAgreement = this.existingEquipmentUpgradeAgreements().find(
      a => a.agreementId === this.equipmentUpgradeAgreementId
    );
    if (this.equipmentUpgradeAgreement?.redemptionId) {
      this.store.dispatch(new ResetRedemptionDetailsAction(this.equipmentUpgradeAgreement.agreementId));
    }
  }

  onSetNewMobilePhoneVariant(newMobilePhoneVariant: HardwareVariant) {
    this.newMobilePhoneVariant = newMobilePhoneVariant;
  }

  onSelectionCompleted() {
    if (this.mobilBytteHelperService.isV2(this.equipmentUpgradeAgreement)) {
      const { agreementId } = this.equipmentUpgradeAgreement;

      this.store.dispatch([
        new SetReturnDetailsAction(+agreementId, MobileReturnMethod.ReturnPackage),
        new AddMobilePhoneReplacementAction(
          this.newMobilePhoneVariant,
          this.newMobileForm.value,
          agreementId,
          this.isManualRegistration
        ),
      ]);
      this.openDialogService.openRegisterMobilbytteDialog(+this.equipmentUpgradeAgreementId, this.data.route);
      return;
    }

    this.onSelectOldMobile();
  }

  onSelectOldMobile() {
    this.isOldMobileSelected = true;
    this.oldMobileSelectionChanged.emit(true);
  }

  onSelectNewMobile() {
    this.isOldMobileSelected = false;
    this.oldMobileSelectionChanged.emit(false);
  }

  onGradingCompleted(eventValues) {
    this.gradingCompleted.emit({
      ...eventValues,
      mobilePhoneDetails: this.newMobileForm.value,
      newMobilePhoneVariant: this.newMobilePhoneVariant,
    });
  }

  get insuranceName(): string {
    if (!this.mobilBytteHelperService.isV2(this.equipmentUpgradeAgreement)) {
      return '';
    }

    return (
      this.assignedMobileInsurances()?.find(
        insurance => insurance.assignedInsurance?.productNo === +this.equipmentUpgradeAgreement?.insuranceServiceId
      )?.assignedInsurance?.monthlyCost?.description || 'Ingen forsikring'
    );
  }

  get insurancePrice(): number {
    return this.equipmentUpgradeAgreement?.monthlyInsuranceAmount?.includingVat ?? 0;
  }

  ngOnDestroy() {
    this.subscriptions$.forEach(sub => sub.unsubscribe());
  }
}
